/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

interface AttributeValuesType {
  RPC_SYSTEM: string;
}

export const AttributeValues: Readonly<AttributeValuesType> = {
  RPC_SYSTEM: 'grpc',
};
